var app = angular.module('leonardo');

var StatsigRestService = function(Restangular, $q) {
  var service = {};
  service.getActiveGates = function(userId) {
    var defer = $q.defer();
    
    Restangular.one('users', userId).customGET('statsig').then(function(response) {
      defer.resolve(response);
    }).catch(function(error) {
      defer.reject(error);
    });
    
    return defer.promise;
  };

  return service;
};

app.factory('StatsigRestService', ['Restangular', '$q', StatsigRestService]);